import { lazy, Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import MainLayout from 'src/layouts/main';
import SupportPage from 'src/pages/faq';
import HomePage from 'src/pages/home';
import { LoadingScreen } from 'src/components/loading-screen';
import { paths } from '../paths';
import { adminRoutes } from './admin';
import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
import { mainRoutes } from './main';
import { organizationDashboardRoutes } from './org-dashboard';
import { settingRoutes } from './setting';
import { skillRoutes } from './skills';
import { userRoutes } from './user';
import { analyticsRoutes } from './analytics';
import { articleRoutes } from './articles';
import { notificationRoutes } from './notifications';

// Pricing page is dormant during Free Beta — keep the import for easy re-enable.
// const PricingPage = lazy(() => import('src/pages/pricing'));
const FreeBetaPage = lazy(() => import('src/pages/free-beta'));
const AboutUsPage = lazy(() => import('src/pages/about-us'));
const PaymentSuccessPage = lazy(() => import('src/pages/payment-success'));
const PrivacyPolicyPage = lazy(() => import('src/pages/privacy-policy'));
const TermsPage = lazy(() => import('src/pages/terms'));


export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <MainLayout>
          <HomePage />
        </MainLayout>
      ),
    },
    {
      path: '/support',
      element: (
        <MainLayout>
          <SupportPage />
        </MainLayout>
      ),
    },
    {
      // /pricing renders the Free Beta page during beta.
      // To re-enable paid pricing: swap FreeBetaPage → PricingPage (already imported above).
      path: '/pricing',
      element: (
        <MainLayout>
          <Suspense fallback={<LoadingScreen />}>
            <FreeBetaPage />
          </Suspense>
        </MainLayout>
      ),
    },
    {
      path: '/about',
      element: (
        <MainLayout>
          <Suspense fallback={<LoadingScreen />}>
            <AboutUsPage />
          </Suspense>
        </MainLayout>
      ),
    },
    {
      path: '/payment/payment-success',
      element: (
        <MainLayout>
          <Suspense fallback={<LoadingScreen />}>
            <PaymentSuccessPage />
          </Suspense>
        </MainLayout>
      ),
    },
    {
      path: '/privacy',
      element: (
        <MainLayout>
          <Suspense fallback={<LoadingScreen />}>
            <PrivacyPolicyPage />
          </Suspense>
        </MainLayout>
      ),
    },
    {
      path: '/terms',
      element: (
        <MainLayout>
          <Suspense fallback={<LoadingScreen />}>
            <TermsPage />
          </Suspense>
        </MainLayout>
      ),
    },
    {
      path: '/dashboard',
      element: <Navigate to={paths.dashboard.root} replace />,
    },

    // Auth routes
    ...authRoutes,

    // Admin routes
    ...adminRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // Organization Dashboard routes
    ...organizationDashboardRoutes,

    // skill routes
    ...skillRoutes,

    // ...settingRoutes,

    ...userRoutes,

    // Article routes
    ...articleRoutes,

    // analytic routes
    ...analyticsRoutes,

    // Notification routes
    ...notificationRoutes,

    // Setting routes
    ...settingRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
